import React, { FC } from 'react';
import styled from 'styled-components';
import { Table, TH } from '../../../components/table/table';
import { IVMIOrder } from '../../../graphql/types';
import { White } from '../../../styles/colours';
import { PtOrderDetailsTableBody } from './potential-table-body';

const StyledOrderDetailsTable = styled(Table)`
  background-color: ${White};
  border-radius: 0.25rem;
`;

interface IOrderDetailsTableProps {
  order: IVMIOrder;
}

const PotentialOrderTable: FC<IOrderDetailsTableProps> = ({ order }) => (
  <StyledOrderDetailsTable>
    <thead>
      <tr>
        <TH align="left">ETA</TH>
        <TH align="left">Tank</TH>
        <TH align="left">Product</TH>
        <TH align="left">Product Code</TH>
        <TH align="left">Potential Volume</TH>
      </tr>
    </thead>
    <PtOrderDetailsTableBody order={order} />
  </StyledOrderDetailsTable>
);

export { PotentialOrderTable };
